module.exports = __webpack_public_path__ + "static/media/bgvideo_m.98ee6c4b.jpg";